import { client } from "../client/client";

export const getModules = async () => {
  try {
    const response = await client.get("/modules");
    return response.data.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
